import React, { useContext, useEffect, createContext } from "react";

// project-imports
import {
    GET_INTERVIEW_CATEGORIES_DATA_BEGIN,
    GET_INTERVIEW_CATEGORIES_DATA_SUCCESS,
    GET_INTERVIEW_CATEGORIES_DATA_FAILURE,
    GET_INTERVIEW_SERIES_DATA_BEGIN,
    GET_INTERVIEW_SERIES_DATA_SUCCESS,
    GET_INTERVIEW_SERIES_DATA_FAILURE,
    GET_INTERVIEW_QUESTIONS_DATA_BEGIN,
    GET_INTERVIEW_QUESTIONS_DATA_SUCCESS,
    GET_INTERVIEW_QUESTIONS_DATA_FAILURE,
    GET_USER_INTERACTION_BY_SERIES_BEGIN,
    GET_USER_INTERACTION_BY_SERIES_SUCCESS,
    GET_USER_INTERACTION_BY_SERIES_FAILURE,
    GET_SERIES_INTERACTION_BY_USER_BEGIN,
    GET_SERIES_INTERACTION_BY_USER_SUCCESS,
    GET_SERIES_INTERACTION_BY_USER_FAILURE,
    ADD_USER_FEEDBACK_BEGIN,
    ADD_USER_FEEDBACK_SUCCESS,
    ADD_USER_FEEDBACK_FAILURE,
    GET_TRENDING_INTERVIEW_SERIES_BEGIN,
    GET_TRENDING_INTERVIEW_SERIES_SUCCESS,
    GET_TRENDING_INTERVIEW_SERIES_FAILURE,
    UPSERT_INTERVIEW_SERIES_USER_INTERACTION_BEGIN,
    UPSERT_INTERVIEW_SERIES_USER_INTERACTION_SUCCESS,
    UPSERT_INTERVIEW_SERIES_USER_INTERACTION_FAILURE,
} from "../constants/actions";
import interviewCategories from "../data/interview-questions/interviewCategories.json";
import interviewSeries from "../data/interview-questions/interview-series.json";
import interviewQuestions from "../data/interview-questions/interview-questions.json";
import { fetchData, postData, updateData } from "./salesforce_api_context";
import { showToast } from "../components/sweet-alert/Sweetalert";
import { useBugContext } from "./bug_context";

// third-party
import { useDispatch, useSelector } from "react-redux";

// Create context
export const InterviewContext = createContext();

export const InterviewProvider = (props) => {
    // Reading dispatch from Store
    const dispatch = useDispatch();

    const { bugReportApi } = useBugContext();

    // Constant variable
    const interviewData = useSelector((state) => state.interview);

    // User varaible
    const loginData = useSelector((state) => state.user)?.loginData;
    const teamMember = loginData && loginData?.data && loginData?.data;

    // Constant function
    // Function to get the Interview-Categories data
    const getInterviewCategories = async () => {
        try {
            // Dispatching the action to begin the api calling process
            dispatch({ type: GET_INTERVIEW_CATEGORIES_DATA_BEGIN, payload: true });

            // Calling API to get data
            // let response = interviewCategories || [];
            let response = await fetchData(`/api/interview/category`);

            // Dispatching the actions on success
            dispatch({
                type: GET_INTERVIEW_CATEGORIES_DATA_SUCCESS,
                payload: response,
            });

            // Showing the toast message on getting instructor Interview-Categories successfully
            // showToast("success", "Getting instructor details successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.log(
                "77 : interview_context : Error while getting gallery data::",
                error && JSON.stringify(error),
            );

            // Dispatching the actions on error
            dispatch({
                type: GET_INTERVIEW_CATEGORIES_DATA_FAILURE,
                payload: error && error.message,
            });

            bugReportApi("Error while fetching interview categories", `/api/interview/category`, "GET", error);
        }
    };

    // Function to get the Interview-Series data
    const getInterviewSeries = async () => {
        try {
            // Dispatching the action to begin the api calling process
            dispatch({ type: GET_INTERVIEW_SERIES_DATA_BEGIN, payload: true });

            // Calling API to get data
            // let response = interviewSeries || [];
            let response = await fetchData(`/api/interview/series`);

            // Dispatching the actions on success
            dispatch({ type: GET_INTERVIEW_SERIES_DATA_SUCCESS, payload: response });

            // Showing the toast message on getting instructor data successfully
            // showToast("success", "Getting instructor details successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.log(
                "108 : interview_context : Error while getting Interview-Series data::",
                error && JSON.stringify(error),
            );

            // Dispatching the actions on error
            dispatch({
                type: GET_INTERVIEW_SERIES_DATA_FAILURE,
                payload: error && error.message,
            });

            bugReportApi("Error while fetching interview series", `/api/interview/series`, "GET", error);
        }
    };

    // Function to get the Interview-Questions data
    const getInterviewQuestions = async () => {
        try {
            // Dispatching the action to begin the api calling process
            dispatch({ type: GET_INTERVIEW_QUESTIONS_DATA_BEGIN, payload: true });

            // Calling API to get data
            // let response = interviewQuestions || [];
            let response = await fetchData(`/api/interview/question`);

            // Dispatching the actions on success
            dispatch({
                type: GET_INTERVIEW_QUESTIONS_DATA_SUCCESS,
                payload: response,
            });

            // Showing the toast message on getting instructor data successfully
            // showToast("success", "Getting instructor details successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.log(
                "142 : interview_context : Error while getting Interview-Questions data::",
                error && JSON.stringify(error),
            );

            // Dispatching the actions on error
            dispatch({
                type: GET_INTERVIEW_QUESTIONS_DATA_FAILURE,
                payload: error && error.message,
            });

            bugReportApi("Error while fetching interview questions", `/api/interview/question`, "GET", error);
        }
    };

    // Send user-interaction
    const upsertSeriesUserInteraction = async (body) => {
        try {
            // Dispatching the action to begin the api calling process
            dispatch({ type: UPSERT_INTERVIEW_SERIES_USER_INTERACTION_BEGIN, payload: true });

            // Api calling for postData
            let response = await postData("/api/interview-series-interaction", body);

            // Dispatching the actions on success
            dispatch({ type: UPSERT_INTERVIEW_SERIES_USER_INTERACTION_SUCCESS, payload: response });
        } catch (error) {
            console.log(
                "169 : interview_context : Error while getting Interview-Questions data::",
                error && JSON.stringify(error),
            );

            // Dispatching the actions on error
            dispatch({
                type: UPSERT_INTERVIEW_SERIES_USER_INTERACTION_FAILURE,
                payload: error && error.message,
            });

            bugReportApi("Error while upsert series user interaction", `/api/interview-series-interaction`, "POST", error);
        }
    };

    // Function to get the Interview-Series by Bookmark
    const getUserInteractionBySeries = async (seriesId) => {
        try {
            // Dispatching the action to begin the api calling process
            dispatch({ type: GET_USER_INTERACTION_BY_SERIES_BEGIN, payload: true });

            // Calling API to get data
            let response = await fetchData(
                `/api/interview-series-interaction/series/${seriesId}`,
            );

            // Dispatching the actions on success
            dispatch({
                type: GET_USER_INTERACTION_BY_SERIES_SUCCESS,
                payload: response,
            });

            // Showing the toast message on getting instructor data successfully
            // showToast("success", "Getting instructor details successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.log(
                "204 : interview_context : Error while getUserInteractionBySeries data::",
                error && JSON.stringify(error),
            );

            // Dispatching the actions on error
            dispatch({
                type: GET_USER_INTERACTION_BY_SERIES_FAILURE,
                payload: error && error.message,
            });

            bugReportApi("Error while fetching user interaction by series", `/api/interview-series-interaction/series/${seriesId}`, "GET", error);
        }
    };

    // Function to get the series Bookmarked by user
    const getSeriesInteractionByUser = async (userId) => {
        try {
            // Dispatching the action to begin the api calling process
            dispatch({ type: GET_SERIES_INTERACTION_BY_USER_BEGIN, payload: true });

            // Calling API to get data
            let response = await fetchData(
                `/api/interview-series-interaction/user/${userId}`,
            );

            // Dispatching the actions on success
            dispatch({ type: GET_SERIES_INTERACTION_BY_USER_SUCCESS, payload: response });

            // Showing the toast message on getting instructor data successfully
            // showToast("success", "Getting instructor details successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.log(
                "236 : interview_context : Error while getting bookmarks by userID data::",
                error && JSON.stringify(error),
            );

            // Dispatching the actions on error
            dispatch({
                type: GET_SERIES_INTERACTION_BY_USER_FAILURE,
                payload: error && error.message,
            });

            bugReportApi("Error while fetching interview series interaction by user", `/api/interview-series-interaction/user/${userId}`, "GET", error);
        }
    };

    // Send user-feedback
    const sendUSerFeedback = async (seriesId, body) => {
        try {
            // Dispatching the action to begin the api calling process
            dispatch({ type: ADD_USER_FEEDBACK_BEGIN, payload: true });

            // Api calling for postData
            let response = await postData(`/api/interview-series-feedback/series/${seriesId}`, body);

            // Dispatching the actions on success
            dispatch({ type: ADD_USER_FEEDBACK_SUCCESS, payload: response });

            showToast(
                "success",
                `Thanks for your feedback.`,
                true,
                "top",
                false,
                true,
                5000
            );

        } catch (error) {
            console.log(
                "274 : interview_context : Error while getting Interview-Questions data::",
                error && JSON.stringify(error),
            );

            // Dispatching the actions on error
            dispatch({
                type: ADD_USER_FEEDBACK_FAILURE,
                payload: error && error.message,
            });

            bugReportApi("Error while post user feedback", `/api/interview-series-feedback/series/${seriesId}`, "POST", error);

            showToast(
                "error",
                `We missed your note! Something went wrong on our end. Please try to send your feedback again.`,
                true,
                "top",
                false,
                true,
                5000
            );
        }
    };

    // Function to get the Trending-Interview-Series data
    const getTrendingInterviewSeries = async () => {
        try {
            // Dispatching the action to begin the api calling process
            dispatch({ type: GET_TRENDING_INTERVIEW_SERIES_BEGIN, payload: true });

            // Calling API to get data
            // let response = interviewCategories || [];
            let response = await fetchData(`/api/interview-series-trend`);

            // Dispatching the actions on success
            dispatch({
                type: GET_TRENDING_INTERVIEW_SERIES_SUCCESS,
                payload: response,
            });

            // Showing the toast message on getting instructor Interview-Categories successfully
            // showToast("success", "Getting instructor details successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.log(
                "318 : interview_context : Error while getting gallery data::",
                error && JSON.stringify(error),
            );

            // Dispatching the actions on error
            dispatch({
                type: GET_TRENDING_INTERVIEW_SERIES_FAILURE,
                payload: error && error.message,
            });

            bugReportApi("Error while fetching trending interview series", `/api/interview-series-trend`, "GET", error);
        }
    };
    useEffect(() => {
        getInterviewCategories();
        getInterviewSeries();
        getInterviewQuestions();
        getTrendingInterviewSeries();

    }, []);

    return (
        <InterviewContext.Provider
            value={{
                ...interviewData,
                getInterviewCategories,
                getInterviewSeries,
                getInterviewQuestions,
                upsertSeriesUserInteraction,
                getUserInteractionBySeries,
                getSeriesInteractionByUser,
                sendUSerFeedback
            }}
        >
            {props.children}
        </InterviewContext.Provider>
    );
};
export const useInterviewContext = () => {
    return useContext(InterviewContext);
};
